import apiClient from "@/api/client";

export type TopologyNodeType = "site" | "pve_node" | "vm" | "vlan";

export interface TopologyNode {
  id: string;
  label: string;
  type: TopologyNodeType;
  data: Record<string, unknown>;
}

export interface TopologyEdge {
  id: string;
  source: string;
  target: string;
  label?: string | null;
  type: string;
}

export interface TopologyGraph {
  nodes: TopologyNode[];
  edges: TopologyEdge[];
}

export async function getTopology(): Promise<TopologyGraph> {
  const { data } = await apiClient.get<TopologyGraph>("/topology");
  return data;
}
